<template>

    <div class="col m-pick">

        <p class="step-caption ft-bld">Select content(s) to add to this row</p>

        <div class="all-outer">
            <div class="all">

                <SnapCard
                    v-for="card, index in assets"
                    :key="index"
                    :posterSrc="card.poster"
                    :title="card.name"
                    @click.native.prevent="moveToSelection(index)"
                >
                </SnapCard>

            </div>
        </div>

        <div class="btm-ovr">

            <div class="selected col">
                <p class="step-caption ft-bld txt-grt">Selected content(s)</p>
                <div class="selection" ref="selection">
                    <SmallCard
                        v-for="selected, index in selectedCards"
                        :key="index"
                        :pos-num="index + 1"
                        :posterSrc="selected.poster"
                        :title="selected.name"
                        @unselect="removeFromSelection"
                    >
                    </SmallCard>
                    <div class="placeholder-cards">
                        <span v-show="selectedCards.length == 0"></span>
                        <span v-show="selectedCards.length <= 1"></span>
                        <span v-show="selectedCards.length <= 2"></span>
                        <span v-show="selectedCards.length <= 3"></span>
                    </div>
                </div>
            </div>

            <div class="nxt-out">
                <div class="btn bck" @click.prevent="switchStep('prv')">
                    <span class="txt">Back</span>
                </div>
                <div class="btn main txt-blk" @click.prevent="submit">
                    <span class="hvr"></span>
                    <span class="txt">Validate</span>
                </div>
            </div>            

        </div>
        
    </div>

</template>

<script>

    import Global from '../../lib/GlobalState'
    import SnapCard from '../SnapCard'
    import SmallCard from '../SmallCard'

    export default {

        name: 'NewRowThreeManual',

        components: {
            SnapCard,
            SmallCard
        },

        data() {
            return {
                Global,
                selectedCards: [],
            }
        },

        computed: {

            displayAfterList() {

                const names = []
                names.push("In first position")

                let rows = Object.assign([], this.Global.rows)

                if(Global.rowIdToEdit) {
                    rows = rows.filter((row) => {
                        return row.id != this.Global.rowIdToEdit
                    })
                }

                rows.map((row) => {
                    names.push("After " + row.name)
                })

                return names
            },

            assets() {
                return Object.assign([], this.Global.assets).map((asset, index) => {
                    asset.index = index
                    return asset
                }).reverse().filter((asset) => {
                    return !this.selectedCards.find((card) => card.index == asset.index)
                })
            }
        },

        mounted() {
            this.$refs.selection.addEventListener("wheel", (event) => {
                event.preventDefault();
                this.$refs.selection.scrollLeft += event.deltaY;
            });

            this.selectedCards = Object.assign([], this.Global.newRowOverlay.assets).map((asset) => {
                return this.Global.assets[asset]
            })
        },

        methods: {

            switchStep(dir) {
                this.$emit(dir)
            },

            moveToSelection(index){
                this.selectedCards.push(this.assets[index]);
            },

            removeFromSelection(index){
                this.selectedCards.splice(index - 1, 1);
            },

            async submit() {
                if(Global.rowIdToEdit) {
                    this.submitEdit()
                } else {
                    this.submitAdd()
                }
            },

            async submitAdd() {
                const row = Object.assign({}, this.Global.newRowOverlay)

                row.id = Date.now()
                row.assets = this.selectedCards.map((asset) => {
                    return asset.index
                })

                const newIndex = this.displayAfterList.findIndex((name) => {
                    return name === this.Global.newRowOverlayDisplayAfter
                })
                
                await this.$parent.closeRowOverlay()
                this.Global.rows.splice(newIndex,0,row)
            },

            async submitEdit() {
                const row = Object.assign({}, this.Global.newRowOverlay)

                row.assets = this.selectedCards.map((asset) => {
                    return asset.index
                })

                const index = this.Global.rows.findIndex((row) => {
                    return row.id == Global.rowIdToEdit
                })
                
                const newIndex = this.displayAfterList.findIndex((name) => {
                    return name === this.Global.newRowOverlayDisplayAfter
                })
                
                await this.$parent.closeRowOverlay()
                this.Global.rows.splice(index,1)
                this.Global.rows.splice(newIndex,0,row)
            }
        }
    }

</script> 